import React from "react";
import { CAlert } from "@coreui/react";
import CIcon from "@coreui/icons-react";

interface PropsInterface {
  className?: string;
  variant?: "alert" | "inline";
}

const DELEGATE_AUTOPAY_TITLE = "AutoPay uses another user's payment method";
const DELEGATE_AUTOPAY_BODY =
  "AutoPay is enabled for this service account using another portal user's payment method. You cannot change or disable AutoPay from this account. Contact the user who enrolled AutoPay to make changes.";

export const DelegateAutopayInfoAlert: React.FC<PropsInterface> = ({
  className = "mb-3",
  variant = "alert",
}) => {
  if (variant === "inline") {
    return (
      <div className={className}>
        <span
          className="payment-method-action-tooltip payment-method-action-tooltip--wide d-inline-block"
          tabIndex={0}
        >
          <span className="text-muted d-block delegate-autopay-info-tooltip-trigger">
            {DELEGATE_AUTOPAY_TITLE}
          </span>
          <span
            className="payment-method-action-tooltip__content"
            role="tooltip"
          >
            {DELEGATE_AUTOPAY_BODY}
          </span>
        </span>
      </div>
    );
  }

  return (
    <CAlert color="info" className={className}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          columnGap: "12px",
          rowGap: "8px",
          alignItems: "start",
        }}
      >
        <CIcon
          name="cis-info-circle"
          size="lg"
          style={{ gridColumn: 1, gridRow: 1, flexShrink: 0 }}
        />
        <span style={{ gridColumn: 2, gridRow: 1, fontWeight: 600 }}>
          {DELEGATE_AUTOPAY_TITLE}
        </span>
        <div style={{ gridColumn: 2, gridRow: 2 }}>{DELEGATE_AUTOPAY_BODY}</div>
      </div>
    </CAlert>
  );
};
